'use client'

import * as stylex from '@stylexjs/stylex'
import type { ComponentPropsWithRef } from 'react'

import { fieldStyles } from '../field'
import type { FieldValueProps } from '../field'
import { fonts, fontSizes, lineHeights } from '../tokens/tokens.stylex'

const styles = stylex.create({
  code: { fontFamily: fonts.mono, fontSize: fontSizes.small, lineHeight: lineHeights.small },
})

type NativeTextareaProps = ComponentPropsWithRef<'textarea'>
type TextareaOptions = { variant?: 'text' | 'code' }

export type TextareaProps = Omit<
  NativeTextareaProps,
  'className' | 'style' | 'value' | 'defaultValue' | 'onChange' | 'readOnly'
> &
  FieldValueProps<NativeTextareaProps> &
  TextareaOptions

/**
 * Edit multiple lines or source text; use Input for a single line. Applications supply labels, validation
 * messages, values, and save handling.
 *
 * Status: supported.
 */
export function Textarea({ variant = 'text', rows = 4, ...props }: TextareaProps) {
  return (
    <textarea
      {...props}
      rows={rows}
      {...stylex.props(fieldStyles.control, fieldStyles.textarea, variant === 'code' && styles.code)}
    />
  )
}
